export const ROUTE_NAMES = {
  HOME: "home",
  LOGIN: "login",
  LOGIN2: "login2",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",
  SUBSCRIPTION: "subscription",
  VERIFY_ACCOUNT: "verify-account",
  NEW_REGISTER: "new-register",
  OLD_REGISTER: "old-register",
  NOT_FOUND: "not-found",
  PROFILE: "profile",
  APPLICANT_INFORMATION: "applicant-information",
} as const;

export type AllowedRedirectRoutes =
  | typeof ROUTE_NAMES.VERIFY_ACCOUNT
  | typeof ROUTE_NAMES.RESET_PASSWORD
  | typeof ROUTE_NAMES.LOGIN;

export const allowedRoutes: Readonly<AllowedRedirectRoutes[]> = [
  ROUTE_NAMES.VERIFY_ACCOUNT,
  ROUTE_NAMES.RESET_PASSWORD,
  ROUTE_NAMES.LOGIN,
];
